<template>
    <kgr-form-scaffold
        :pending="pending"
        :pending-delete="pendingRemove"
        :with-delete-button="isDeletable"
        edit-mode
        :with-primary-buttons="isEditable"
        @primaryBtnClicked="updateMember"
        @deleteBtnClicked="removeMember"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-member-data-provider
            :member-id="memberId"
            :callback="onMemberLoaded"
        >
            <div class="animated fadeIn">
                <kgr-member-basic-data-form
                    :member="member"
                    :club-id="clubId"
                    :error="error"
                    @enter="updateMember"
                />
            </div>
        </kgr-member-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import MemberBasicDataForm from '../../components/members/MemberBasicDataForm';
import MemberDataProvider from '../../components/data-provider/MemberDataProvider';
import MemberRepository from '../../js/repository/MemberRepository';

export default {
    components: {
        'kgr-member-data-provider': MemberDataProvider,
        'kgr-member-basic-data-form': MemberBasicDataForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            pendingRemove: false,
            error: new Error(),
            member: null,
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onMemberLoaded(loadedMember) {
            this.member = loadedMember;
        },
        removeMember() {
            showConfirm(this.$t('confirm'), this.$t('member.delete.confirm', {'member': this.member.fullName()}), () => {
                this.pendingRemove = true;
                MemberRepository.remove(this.member.id)
                    .then(() => {
                        this.error = new Error();
                        this.$notify.success('Mitglied erfolgreich gelöscht', {}, { saveInSession: true });
                        this.redirectToOverview();
                    })
                    .catch(error => {
                        this.handleError(error);
                        this.pendingRemove = false
                    });
            }, 'Ok');
        },
        updateMember() {
            if (!this.isEditable) {
                return;
            }
            this.pending = true;
            MemberRepository.updateProfile(this.member)
                .then(() => {
                    this.error = new Error();
                    this.$notify.success('saveChanges.success');
                    this.pending = false;
                })
                .catch(error => {
                    this.handleError(error);
                    this.pending = false;
                });
        },
        handleError(error) {
            this.error = error;
            this.$notify.error(error.message ?? 'saveChanges.error');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
